var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 0V128H448L320 0Z",
    fill: "#02A3E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320 160C302.368 160 288 145.632 288 128V0H96C78.368 0 64 14.368 64 32V480C64 497.664 78.368 512 96 512H416C433.664 512 448 497.664 448 480V160H320ZM192 448H128V352H192V448ZM288 448H224V288H288V448ZM384 448H320V224H384V448Z",
    fill: "#02A3E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportManager);
export default __webpack_public_path__ + "static/media/report-manager.ec6efca357ca5480e64ea98fd34d6157.svg";
export { ForwardRef as ReactComponent };